"use strict";

exports.__esModule = true;
exports.useChildrenEnterLeave = useChildrenEnterLeave;

var _reactUtils = require("@okee-uikit/react-utils");

var _reactHooks = require("@okee-uikit/react-hooks");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function useChildrenEnterLeave(children, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$childRefKey = _options.childRefKey,
      childRefKey = _options$childRefKey === void 0 ? 'ref' : _options$childRefKey,
      disabled = _options.disabled,
      duration = _options.duration,
      enterChildProps = _options.enterChildProps,
      ignoreInitialRender = _options.ignoreInitialRender,
      leaveChildProps = _options.leaveChildProps,
      moveChildProps = _options.moveChildProps,
      onFrameAnimationEnd = _options.onFrameAnimationEnd,
      _options$skipChildWit = _options.skipChildWithoutRef,
      skipChildWithoutRef = _options$skipChildWit === void 0 ? true : _options$skipChildWit,
      timingFunction = _options.timingFunction,
      _options$updateAfterA = _options.updateAfterAnimation,
      updateAfterAnimation = _options$updateAfterA === void 0 ? true : _options$updateAfterA;

  var _getEnterLeaveMoveTic = getEnterLeaveMoveTick(options),
      enterTick = _getEnterLeaveMoveTic.enterTick,
      leaveTick = _getEnterLeaveMoveTic.leaveTick,
      moveTick = _getEnterLeaveMoveTic.moveTick;

  var getEnterChildProps = isNotPropsGetter(enterChildProps) ? function () {
    return enterChildProps;
  } : enterChildProps;
  var getLeaveChildProps = isNotPropsGetter(leaveChildProps) ? function () {
    return leaveChildProps;
  } : leaveChildProps;
  var getMoveChildProps = isNotPropsGetter(moveChildProps) ? function () {
    return moveChildProps;
  } : moveChildProps;
  var forceUpdate = (0, _reactHooks.useUpdate)();
  var initialRender = (0, _react.useRef)(true);
  var leavingKeys = (0, _reactHooks.useSingleton)(function () {
    return new Set();
  });
  var enteringKeys = (0, _reactHooks.useSingleton)(function () {
    return new Set();
  });
  var movingKeys = (0, _reactHooks.useSingleton)(function () {
    return new Map();
  });
  var childMap = new Map();
  var prevChildMap = (0, _reactHooks.usePrevProp)(childMap, function () {
    return false;
  })[1];
  var domNodeMap = (0, _reactHooks.useSingleton)(function () {
    return new Map();
  });
  var handleFrameAnimationEnd = (0, _reactHooks.useRefCallback)(function () {
    onFrameAnimationEnd === null || onFrameAnimationEnd === void 0 ? void 0 : onFrameAnimationEnd();

    if (updateAfterAnimation) {
      forceUpdate();
    }
  });
  (0, _react.useEffect)(function () {
    initialRender.current = false;
  }, []);

  if (disabled || ignoreInitialRender && initialRender.current) {
    _react.default.Children.toArray(children).forEach(function (child, index) {
      if (_react.default.isValidElement(child) && child.key) {
        childMap.set(child.key, [index, child]);
      }
    });

    return [children, function () {
      return function () {
        return void 0;
      };
    }];
  }

  var childRef = function childRef(key) {
    return function (element) {
      if (element) {
        domNodeMap.set(key, _extends({}, domNodeMap.get(key), {
          element: element
        }));
      } else if (!enteringKeys.has(key) && !leavingKeys.has(key) && !movingKeys.has(key)) {
        domNodeMap.delete(key);
      }
    };
  };

  var handleClone = function handleClone(child, index) {
    var _ref;

    if (!_react.default.isValidElement(child) || !child.key) {
      return child;
    }

    var key = child.key;
    var exists = prevChildMap !== childMap && prevChildMap.get(key);
    var moved = exists && exists[0] !== index;
    var rewriteProps = !exists ? getEnterChildProps(child.props, key) : moved ? getMoveChildProps(child.props, key, exists[0] - index) : {};

    if (exists) {
      prevChildMap.delete(key);
      moved && movingKeys.set(key, exists[0] - index);
    } else {
      leavingKeys.delete(key);
      enteringKeys.add(key);
    }

    var refKey = typeof childRefKey === 'function' ? childRefKey(child) : childRefKey;

    var reactNode = _react.default.cloneElement(child, _extends({}, rewriteProps, refKey ? (_ref = {}, _ref[refKey] = childRef(key), _ref) : {}));

    childMap.set(key, [index, reactNode]);
    return reactNode;
  };

  var clonedChildren = _react.default.Children.toArray(children).map(handleClone);

  if (prevChildMap !== childMap) {
    prevChildMap.forEach(function (_ref2, key) {
      var _ref3;

      var index = _ref2[0],
          child = _ref2[1];
      leavingKeys.add(key);
      enteringKeys.delete(key);
      var refKey = typeof childRefKey === 'function' ? childRefKey(child) : childRefKey;

      var reactNode = _react.default.cloneElement(child, _extends({}, getLeaveChildProps(child.props, key), refKey ? (_ref3 = {}, _ref3[refKey] = childRef(key), _ref3) : {}));

      clonedChildren.splice(index, 0, reactNode);
    });
  }

  if (!leavingKeys.size && !enteringKeys.size && !movingKeys.size) {
    return [children, function () {
      return function () {
        return void 0;
      };
    }];
  }

  if (duration === undefined || !enterTick && !leaveTick && !moveTick) {
    return [children, function () {
      return function () {
        return void 0;
      };
    }];
  }

  var durations = getDuration(duration);
  var timings = getTimingFunction(timingFunction);

  var tick = function tick(now) {
    if (now === void 0) {
      now = performance.now();
    }

    if (enterTick) {
      enteringKeys.forEach(function (key) {
        var domNode = getDomNode(domNodeMap, enteringKeys, key, skipChildWithoutRef);

        var _getPercent = getPercent(domNode, now, durations, timings, 'enter'),
            percent = _getPercent.percent,
            finished = _getPercent.finished;

        if (finished) {
          enteringKeys.delete(key);

          if (!domNode.element) {
            domNodeMap.delete(key);
          }
        }

        if (domNode.element) {
          domNode.memo = enterTick(domNode.element, percent, domNode.memo, key);
        }
      });
    } else {
      enteringKeys.clear();
    }

    if (leaveTick) {
      leavingKeys.forEach(function (key) {
        var domNode = getDomNode(domNodeMap, leavingKeys, key, skipChildWithoutRef);

        var _getPercent2 = getPercent(domNode, now, durations, timings, 'leave'),
            percent = _getPercent2.percent,
            finished = _getPercent2.finished;

        if (finished) {
          leavingKeys.delete(key);

          if (!domNode.element) {
            domNodeMap.delete(key);
          }
        }

        if (domNode.element) {
          domNode.memo = leaveTick(domNode.element, percent, domNode.memo, key);
        }
      });
    } else {
      leavingKeys.clear();
    }

    if (moveTick) {
      movingKeys.forEach(function (moved, key) {
        var domNode = getDomNode(domNodeMap, movingKeys, key, skipChildWithoutRef);

        var _getPercent3 = getPercent(domNode, now, durations, timings, 'move'),
            percent = _getPercent3.percent,
            finished = _getPercent3.finished;

        if (finished) {
          movingKeys.delete(key);

          if (!domNode.element) {
            domNodeMap.delete(key);
          }
        }

        if (domNode.element) {
          domNode.memo = moveTick(domNode.element, percent, moved, domNode.memo, key);
        }
      });
    } else {
      movingKeys.clear();
    }

    if (!enteringKeys.size && !leavingKeys.size && !movingKeys.size) {
      tick.frame = undefined;
      handleFrameAnimationEnd();
    } else {
      tick.frame = requestAnimationFrame(tick);
    }
  };

  var start = function start() {
    tick.frame = requestAnimationFrame(tick);
    return function () {
      tick.frame !== undefined && cancelAnimationFrame(tick.frame);
    };
  };

  return [clonedChildren, start];
}

function getDomNode(map, keys, key, skipChildWithoutRef) {
  var domNode = map.get(key);

  if (!domNode) {
    domNode = {};
    map.set(key, domNode);
  }

  if (!domNode.element) {
    if (skipChildWithoutRef) {
      map.delete(key);
      keys.delete(key);
    }
  } else if (!domNode.element.isConnected) {
    map.delete(key);
    keys.delete(key);
  }

  return domNode;
}

function getPercent(domNode, now, durations, timings, type) {
  var _a;

  domNode.startTime = (_a = domNode.startTime) !== null && _a !== void 0 ? _a : now;
  var cost = now - domNode.startTime;
  var finished = cost >= durations[type];
  var percent = finished ? 1 : timings[type](cost / durations[type]);
  return {
    percent: percent,
    finished: finished
  };
}

function getEnterLeaveMoveTick(options) {
  var enter = options.enterTick,
      leave = options.leaveTick,
      moveTick = options.moveTick;
  var enterTick = enter !== null && enter !== void 0 ? enter : leave && function (a, b, c, d) {
    return leave(a, 1 - b, c, d);
  };
  var leaveTick = leave !== null && leave !== void 0 ? leave : enter && function (a, b, c, d) {
    return enter(a, 1 - b, c, d);
  };
  return {
    enterTick: enterTick,
    leaveTick: leaveTick,
    moveTick: moveTick
  };
}

function isNotPropsGetter(value) {
  return typeof value !== 'function';
}

function getTimingFunction(value) {
  if (value === void 0) {
    value = {};
  }

  var defaultMap = {
    enter: _reactUtils.presets.easeOut,
    leave: _reactUtils.presets.easeIn,
    move: _reactUtils.presets.easeInOut
  };

  if (typeof value === 'string') {
    return {
      enter: _reactUtils.presets[value],
      leave: _reactUtils.presets[value],
      move: _reactUtils.presets[value]
    };
  }

  if (Array.isArray(value)) {
    var getter = _reactUtils.cubicBezier.apply(void 0, value);

    return {
      enter: getter,
      leave: getter,
      move: getter
    };
  }

  return Object.keys(value).reduce(function (prev, curr) {
    var _extends2;

    var item = value[curr];
    return _extends({}, prev, (_extends2 = {}, _extends2[curr] = typeof item === 'string' ? _reactUtils.presets[item] : _reactUtils.cubicBezier.apply(void 0, item), _extends2));
  }, defaultMap);
}

function getDuration(value) {
  if (value === void 0) {
    value = 0;
  }

  return typeof value === 'number' ? {
    enter: value,
    leave: value,
    move: value
  } : value;
}

if (typeof window !== 'undefined') {
  if (!('isConnected' in Node.prototype)) {
    Object.defineProperty(Node.prototype, 'isConnected', {
      get: function get() {
        return !this.ownerDocument || !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
      }
    });
  }
}